import { useEffect, useState } from "react";
import { ChildrenStoreData, Framework } from "src/shared/types/src";
import { FRAMEWORK_TIERS } from "src/shared/config/src";
import TierOne from "./frameworkTiers/TierOne";
import TierTwo from "./frameworkTiers/TierTwo";
import TierThree from "./frameworkTiers/TierThree";
import TierFour from "./frameworkTiers/TierFour";
import TierFive from "./frameworkTiers/TierFive";
import { fetchObservationFrameworks } from "src/shared/services/src";
import { ObservationFrameworksLoader } from "src/app/components";

const ObservationFrameworks = ({ currentChild, observationId }: { currentChild: ChildrenStoreData, observationId: string }) => {
    const [frameworks, setFrameworks] = useState<Framework[]>([]);
    const [observationFrameworkLoading, setObservationFrameworkLoading] = useState<boolean>(false);

    useEffect(() => {
        getFrameworkDetails(observationId);
    }, [observationId]);

    const getFrameworkDetails = async (observationId: string) => {
        try {
            setObservationFrameworkLoading(true);
            const response = await fetchObservationFrameworks({ child: currentChild, observationId });
            if (response && Object.keys(response).length) {
                setFrameworks(response.frameworks);
            } else setFrameworks([]);
        } catch (error) {
            setFrameworks([]);
        } finally {
            setObservationFrameworkLoading(false);
        }
    }

    const renderTiers = (framework: Framework, index: number) => {
        if (!framework) return null;
        switch (framework.tierType) {
            case FRAMEWORK_TIERS.TIER_1:
                return <TierOne  _framework={framework} expand={index === 0} />
            case FRAMEWORK_TIERS.TIER_2:
                return <TierTwo _framework={framework} expand={index === 0} />
            case FRAMEWORK_TIERS.TIER_3:
                return <TierThree _framework={framework} expand={index === 0} />
            case FRAMEWORK_TIERS.TIER_4:
                return <TierFour _framework={framework} expand={index === 0} />
            case FRAMEWORK_TIERS.TIER_5:
                return <TierFive _framework={framework} expand={index === 0} />
            default:
                return null
        }
    }

    const renderFrameworks = () => {
        return (
            <>
            {
                frameworks.map((framework, index) => (
                    <>
                        {renderTiers(framework, index)}
                    </>
                ))
            }
            </>
        )
    }

    return (
        <>
        {
            observationFrameworkLoading ?
            <ObservationFrameworksLoader /> : 
            <div className='mg-t-10 mx-n-20'>
            { renderFrameworks() }
            </div>
        }
        </>
    )
}

export default ObservationFrameworks;